import {
  CommonActions,
  NavigationProp,
  useIsFocused,
  useNavigation,
} from '@react-navigation/native';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAnalytics } from 'services/analytics/useAnalytics';
import { RootState } from 'store/index';
import { Platform } from 'utils/platform';

export default function (props: any) {
  const isFocused = useIsFocused();
  const analytics = useAnalytics();
  const [hardResetKey, setHardResetKey] = React.useState<number>();
  const user = useSelector((state: RootState) => state.auth);
  const navigation = useNavigation<NavigationProp<any>>();

  let ScreenComponent: any;

  if (Platform.isTV) {
    ScreenComponent = require('./Login.ctv').default;
  } else {
    ScreenComponent = require('./Login').LoginScreenComponent;
  }

  React.useEffect(() => {
    setHardResetKey(new Date().getTime());
  }, [isFocused]);

  React.useEffect(() => {
    if (user.isAuthenticated && isFocused) {
      navigation.dispatch(
        CommonActions.reset({
          index: 0,
          routes: [{ name: 'Home' }],
        })
      );

      if (user.id) {
        analytics.triggerSetUserId(user.id);
      }
    }
  }, [user, navigation, isFocused]);

  if (!ScreenComponent) return null;

  return <ScreenComponent key={hardResetKey} {...props} />;
}
